export const ALERT_BANNERS = {
  BETA: 'beta',
};



// WEBPACK FOOTER //
// ./src/constants/alertBanners.js